import { render } from "./SliderScroll.vue?vue&type=template&id=6aa2b42a&scoped=true"
import script from "./SliderScroll.vue?vue&type=script&lang=js"
export * from "./SliderScroll.vue?vue&type=script&lang=js"

import "./SliderScroll.vue?vue&type=style&index=0&id=6aa2b42a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa2b42a"]])

export default __exports__